import React from 'react'
import './winner-autopauta.scss'
// import { useStaticQuery, graphql } from "gatsby"

const WinnerAutopauta = (props) => {
  const [pageLoad, setPageLoad] = React.useState(false)
  React.useEffect(() => {
    setPageLoad(true)
  }, [])

  const allContentIsHidden = () => {
    let finalState = true
    if (props.autopauta) {
      for (let index = 0; index <= props.autopauta.length - 1; index++) {
        finalState = finalState && props.autopauta[index].titulo === 'contenido-oculto'
      }
    }
    return finalState
  }

  if (props.autopauta && !allContentIsHidden()) {
    return (
      <aside className="f-autopauta-winners-container">
        <div className="f-top-autopauta">
          <p className="f-top-autopauta-title">MÁS <span>CONCURSOS</span></p>
          {props.autopauta.map((autopautaitem, index) => {
            if (typeof autopautaitem.autopautaConcurso !== 'undefined' && autopautaitem.titulo !== 'contenido-oculto') {
              return (
                <a key={index} href={autopautaitem.redireccionParaParticipar !== null ? autopautaitem.redireccionParaParticipar : "/magazin/concursos/" + autopautaitem.slug} className="f-top-autopauta-winners">
                  <img alt={autopautaitem.autopautaConcurso.description} src={pageLoad ? autopautaitem.autopautaConcurso.file.url : autopautaitem.autopautaConcurso.fixed.base64} />
                  <h3>{autopautaitem.titulo}</h3>
                  <p>{autopautaitem.descripcionConcurso.descripcionConcurso}</p>
                </a>
              )
            } else {
              return null
            }
          })}

        </div>
      </aside>
    )

  } else {
    return null
  }
}

export default WinnerAutopauta
